/* import __COLOCATED_TEMPLATE__ from './lightbox-image-opener.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();